






import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'UCTab',
  props: {
    value: {
      type: String,
      required: true,
    },
    registerTab: {
      type: Function,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: [String, Array],
      default: '',
    },
    activeTab: {
      type: String,
      default: '',
    },
  },
  computed: {
    isSelected(): boolean {
      return this.activeTab === this.value;
    },
  },
  mounted() {
    // @ts-ignore migrated from ui-library
    this.registerTab(this.value);
  },
  methods: {
    handleClick() {
      this.$emit('on-tab-selected', this.value);
    },
  },
});
